import { TranslationKeysByPath } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

const baseTranslationPath = 'data_source_edit:code.check_installation';

type CheckInstallationMessageProps = {
  text: TranslationKeysByPath<typeof baseTranslationPath>;
  translationValues?: Record<string, string>;
  classNames?: string;
  asListItem?: boolean;
};

export const CheckInstallationMessage: FC<CheckInstallationMessageProps> = ({ text, translationValues, asListItem, classNames }) => {
  const { t } = useTranslation();

  const Element = asListItem ? 'li' : 'p';
  const semibold = Element === 'p';

  const message = `${baseTranslationPath}.${text}`;

  return (
    <Element className={twMerge('text-sm font-normal leading-5 text-gray-600', semibold && 'font-semibold', classNames)}>
      {t(message as any, { ...translationValues })}
    </Element>
  );
};
